import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/CreateRubricAI/PageProvider';
import { DesktopForm, DesktopLoading, DesktopResult } from 'pages/CreateRubricAI/desktop';
import { MobileForm, MobileLoading, MobileResult } from 'pages/CreateRubricAI/mobile';
import { TabletForm, TabletLoading, TabletResult } from 'pages/CreateRubricAI/tablet';
import { useContext } from 'react';

const PageLayout = () => {
    const { device } = useViewport();

    const {
        form,
        errors,
        onChange,
        onClickAddCriterion,
        onClickDeleteCriterion,

        isLoading,
        onClickBack,

        result,
        setResult,
        rubricErrors,
        setRubricErrors,
        hasClickedSubmitRubric,
        setHasClickedSubmitRubric,
        validateTitle,
        validateCriteria,
        onClickEditSettings,
    } = useContext(PageContext);

    const formProps = {
        form,
        errors,
        onChange,
        onClickAddCriterion,
        onClickDeleteCriterion,
    };

    const loadingProps = {
        isLoading,
        onClickBack,
    };

    const resultProps = {
        result,
        setResult,
        rubricErrors,
        setRubricErrors,
        hasClickedSubmitRubric,
        setHasClickedSubmitRubric,
        validateTitle,
        validateCriteria,
        onClickEditSettings,
    };

    const renderForm = (device) => {
        return {
            mobile: <MobileForm {...formProps} />,
            tablet: <TabletForm {...formProps} />,
            desktop: <DesktopForm {...formProps} />,
        }[device];
    };

    const renderLoading = (device) => {
        return {
            mobile: <MobileLoading {...loadingProps} />,
            tablet: <TabletLoading {...loadingProps} />,
            desktop: <DesktopLoading {...loadingProps} />,
        }[device];
    };

    const renderResult = (device) => {
        return {
            mobile: <MobileResult {...resultProps} />,
            tablet: <TabletResult {...resultProps} />,
            desktop: <DesktopResult {...resultProps} />,
        }[device];
    };

    if (isLoading) return renderLoading(device);
    if (result) return renderResult(device);
    return renderForm(device);
};

export default PageLayout;
